module.exports = __webpack_public_path__ + "readmore_arrow-9204c0b507747ceb4779.svg";